/**
 * The longest a line of running text runs, as the ground sets it (`--broker-measure` in `broker.module.css`): about 70
 * characters, so a lead line or a notice reads as a paragraph rather than a line across a 1900px window. A form's
 * fields and a step's cards take the width; the words about them don't.
 */
export const READING_MEASURE = 'var(--broker-measure)';
